<template>
  <div class="ms-container">
    <module-header>
      Справочники
    </module-header>
    <div class="books">
      <row :gutter="16">
        <i-col span="6">
          <books-list
            :active-book="activeBook"
            @change-book="changeBook"
            :books="filteredBooks"
          />
        </i-col>
        <i-col span="12">
          <inline-loader v-if="loading" :loading="loading" />
          <books-editor
            v-else-if="activeBook"
            :active-book="activeBook"
            :active-book-type="activeBookType"
            :active-book-name="activeBookName"
            :active-book-label="activeBookLabel"
            :active-book-attributes="activeBookAttrs"
            :active-book-requests="activeBookRequests"
            :active-book-required="activeBookRequired"
            :active-book-create-disabled="activeBookCreateDisabled"
            :active-book-delete-disabled="activeBookDeleteDisabled"
            :values="values"
            :permissions="permissions"
            @edit-handler="loadValues"
          />
        </i-col>
      </row>
    </div>
  </div>
</template>

<script>
import ModuleHeader from '@/components/parts/module-header'
import BooksList from '@/components/books/books-list'
import BooksEditor from '@/components/books/books-editor'
import InlineLoader from '@/components/loaders/inline-loader'
import books from '@/config/books'

export default {
  components: {
    ModuleHeader,
    BooksList,
    BooksEditor,
    InlineLoader
  },
  data () {
    return {
      url: books[0].url,
      activeBook: books[0].value,
      activeBookName: books[0].name,
      activeBookType: books[0].type,
      activeBookLabel: books[0].label,
      activeBookAttrs: books[0].attributes,
      activeBookRequired: books[0].required,
      activeBookRequests: books[0].requests,
      activeBookCreateDisabled: books[0].createDisabled,
      activeBookDeleteDisabled: books[0].deleteDisabled,
      values: [],
      loading: false,
      books
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissionModule('books')
    },
    filteredBooks () {
      return books.filter(({ value }) => this.permissions[value] && this.permissions[value].read)
    }
  },
  methods: {
    async changeBook ({
      value,
      name,
      type,
      url,
      label,
      attributes,
      requests,
      required,
      createDisabled,
      deleteDisabled
    }) {
      if (this.activeBook === value) return

      this.url = url
      this.activeBook = value
      this.activeBookType = type
      this.activeBookName = name
      this.activeBookLabel = label
      this.activeBookAttrs = attributes
      this.activeBookRequests = requests
      this.activeBookRequired = required
      this.activeBookCreateDisabled = createDisabled
      this.activeBookDeleteDisabled = deleteDisabled

      await this.loadValues()
    },
    async loadValues () {
      if (!this.activeBook) return

      try {
        this.loading = true
        const url = this.url || `${this.activeBookType}/${this.activeBook}`
        this.values = await this.$store.dispatch('GET_REQUEST', { url })
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    }
  },
  created () {
    this.loadValues()
  }
}
</script>

<style lang="less">
</style>
